import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  overflow: hidden;
`;

/**
 * The `transform` property fixes flickering
 * under `safe-area` on iOS when scrolling the screen.
 */
export const ButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 1px;
  border-top: 2px solid ${(p) => p.theme.lightTransparent};
  transform: translateZ(0);
`;

/**
 * No need to create another stacking context here,
 * because `SwipeProvider` has `will-change` declared,
 * which itself creates a new context.
 */
export const SwipeContainer = styled.div``;
